import { Module } from 'vuex';
import { engagementVideo } from '@/video/engagement/store/engagement-video.store';
import { RootState } from '@/store/store';
import { IVideoState } from '@/video/store/video.store.types';
import { videoLibraryOld } from '@/video/library-old/store/video-library-old.store';
import { videoLink } from '@/video/link/store/video-link.store';
import { videoRecorder } from '@/video/recorder/store/video-recorder.store';

export const video: Module<IVideoState, RootState> = {
  modules: {
    videoLibraryOld,
    videoLink,
    videoRecorder,
    engagementVideo,
  },
  namespaced: true,
};
